module.exports = __webpack_public_path__ + "static/media/siddharth-palamaner-trip-04.d14962e9.png";